import React, { useEffect } from 'react';
import { Modal } from 'src/features/common';
import { BlueTick } from 'src/assets/images';
import TealiumEvents from 'src/helpers/tealium-events';
import { terminalsRoute } from 'src/routing/routes';
import { useHistory } from 'react-router-dom';

type TerminalModalProps = {
  show: boolean;
  isSuccess: boolean;
  setShow: React.Dispatch<React.SetStateAction<boolean>>;
};

const TerminalModal = ({ show, setShow, isSuccess }: TerminalModalProps) => {
  function handleClose() {
    setShow(false);
  }
  const history = useHistory();
  useEffect(() => {
    if (isSuccess) {
      TealiumEvents.receivedTerminalUpdateModalExit();
    } else {
      TealiumEvents.inProgressTerminalUpdateModal();
      TealiumEvents.receivedTerminalUpdateModalExit();
    }
  }, []);

  function handleSuccess() {
    setShow(false);
    history.push(terminalsRoute);
  }
  return (
    <Modal visible={show} size="extra-small" onClose={handleClose}>
      <div className="flex flex-col gap-10 items-center">
        {isSuccess ? <img src={BlueTick} alt="blue tick" /> : ''}
        <h1 className="text-grey-600 text-4xl text-center">
          {isSuccess ? 'We’ve received your update request' : 'Update in progress'}
        </h1>
        <p className="text-grey-400 text-base w-full max-w-xs text-center">
          {isSuccess
            ? 'We’ll send you an email as well as an SMS once the details have been updated'
            : 'We are processing your update Please try again later.'}
        </p>
        <div className="w-6 h-1 m-0 md:hidden mb-4 bg-red-600" />
        <button
          type="button"
          className="max-w-xs w-full h-11 text-white bg-red-500  rounded-40"
          onClick={() => handleSuccess()}
        >
          {isSuccess ? 'Exit' : ' Okay!'}
        </button>
      </div>
    </Modal>
  );
};

export default TerminalModal;
